/**
 * Privacy Policy Data
 * Contains all content for the Privacy Policy page
 */

export const privacySections = [
  {
    id: 1,
    title: "Introduction",
    content: [
      "SoundArt (\"we,\" \"our,\" or \"us\") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and use our services.",
      "Please read this privacy policy carefully. If you do not agree with the terms of this privacy policy, please do not access the site."
    ]
  },
  {
    id: 2,
    title: "Information We Collect",
    subsections: [
      {
        title: "2.1 Personal Information",
        content: [
          "We may collect personal information that you voluntarily provide to us when you:"
        ],
        list: [
          "Register for an account",
          "Subscribe to our newsletter or concert alerts",
          "Purchase tickets or merchandise",
          "Contact us for support",
          "Participate in surveys or promotions"
        ],
        additionalContent: [
          "This information may include:"
        ],
        additionalList: [
          "Name and contact information (email, phone number)",
          "Billing and shipping addresses",
          "Payment information (processed securely by third-party providers)",
          "Preferences and interests"
        ]
      },
      {
        title: "2.2 Automatically Collected Information",
        content: [
          "We automatically collect certain information when you visit our website:"
        ],
        list: [
          "IP address and location data",
          "Browser type and version",
          "Device information",
          "Pages visited and time spent on site",
          "Referring website",
          "Cookies and similar tracking technologies"
        ]
      }
    ]
  },
  {
    id: 3,
    title: "How We Use Your Information",
    content: [
      "We use the information we collect to:"
    ],
    list: [
      "Provide and maintain our services",
      "Process transactions and send related information",
      "Send you concert alerts and promotional materials",
      "Respond to your comments and questions",
      "Improve our website and services",
      "Analyze usage patterns and trends",
      "Prevent fraud and enhance security",
      "Comply with legal obligations"
    ]
  },
  {
    id: 4,
    title: "Information Sharing and Disclosure",
    content: [
      "We do not sell, trade, or rent your personal information to third parties. We may share your information in the following circumstances:"
    ],
    list: [
      "Service Providers: With trusted third parties who assist us in operating our website and conducting our business",
      "Legal Requirements: When required by law or to protect our rights and safety",
      "Business Transfers: In connection with a merger, acquisition, or sale of assets",
      "Consent: When you have given us explicit consent to share your information"
    ]
  },
  {
    id: 5,
    title: "Data Security",
    content: [
      "We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet or electronic storage is 100% secure.",
      "We use industry-standard encryption for sensitive data and regularly review our security practices to ensure your information is protected."
    ]
  },
  {
    id: 6,
    title: "Cookies and Tracking Technologies",
    content: [
      "We use cookies and similar tracking technologies to enhance your experience on our website. Cookies are small data files stored on your device that help us:"
    ],
    list: [
      "Remember your preferences and settings",
      "Analyze website traffic and usage patterns",
      "Provide personalized content and advertisements",
      "Improve website functionality"
    ],
    additionalContent: [
      "You can control cookie settings through your browser preferences. However, disabling cookies may affect the functionality of our website."
    ]
  },
  {
    id: 7,
    title: "Your Rights and Choices",
    content: [
      "Depending on your location, you may have the following rights regarding your personal information:"
    ],
    list: [
      "Access: Request access to your personal information",
      "Correction: Request correction of inaccurate information",
      "Deletion: Request deletion of your personal information",
      "Portability: Request transfer of your data to another service",
      "Opt-out: Unsubscribe from marketing communications",
      "Restriction: Request restriction of processing"
    ],
    additionalContent: [
      "To exercise these rights, please contact us using the information provided in the \"Contact Us\" section below."
    ]
  },
  {
    id: 8,
    title: "Data Retention",
    content: [
      "We retain your personal information only for as long as necessary to fulfill the purposes outlined in this privacy policy, unless a longer retention period is required or permitted by law. When we no longer need your information, we will securely delete or anonymize it."
    ]
  },
  {
    id: 9,
    title: "Third-Party Links",
    content: [
      "Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of these external sites. We encourage you to review the privacy policies of any third-party sites you visit."
    ]
  },
  {
    id: 10,
    title: "Children's Privacy",
    content: [
      "Our services are not intended for children under 13 years of age. We do not knowingly collect personal information from children under 13. If you are a parent or guardian and believe your child has provided us with personal information, please contact us immediately."
    ]
  },
  {
    id: 11,
    title: "International Data Transfers",
    content: [
      "Your information may be transferred to and processed in countries other than your own. We ensure that such transfers comply with applicable data protection laws and implement appropriate safeguards to protect your information."
    ]
  },
  {
    id: 12,
    title: "Changes to This Privacy Policy",
    content: [
      "We may update this privacy policy from time to time. We will notify you of any changes by posting the new privacy policy on this page and updating the \"Last updated\" date. We encourage you to review this privacy policy periodically for any changes."
    ]
  },
  {
    id: 13,
    title: "Contact Us",
    content: [
      "If you have any questions about this Privacy Policy or our privacy practices, please contact us:"
    ],
    contactInfo: {
      email: "privacy@soundart.com",
      phone: "(356) 1234 1234",
      address: "112, Roy Buildings, JC Roads, RY"
    }
  }
];

